import { createContext, useContext } from "react"
import { useMotionValue } from "framer-motion"
import { useNav } from "components/nav-v2/Wrapper"
import { useMotionValueEvent } from "framer-motion"

export const Context = createContext()

export const PanelModalProvider = ({ children }) => {
  const panelModalState = useMotionValue(false)
  const nav = useNav()

  useMotionValueEvent(nav.main.panes.motion.expanded, "change", latest => {
    const previous = nav.main.panes.motion.expanded.getPrevious()

    if (Number.isInteger(previous) || Number.isInteger(latest)) {
      panelModalState.set(!!latest)
    }
  })

  useMotionValueEvent(nav.sub.pane.motion.expanded, "change", latest => {
    const previous = nav.sub.pane.motion.expanded.getPrevious()

    if (Number.isInteger(previous) || Number.isInteger(latest)) {
      panelModalState.set(!!latest)
    }
  })

  return <Context.Provider value={{ panelModalState }}>{children}</Context.Provider>
}

export const usePanelModal = () => useContext(Context)
